const initialState = {};

const rehydrate = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default rehydrate;
